import { render, staticRenderFns } from "./NotesAndFilesTab.vue?vue&type=template&id=be7b9d16&scoped=true&"
import script from "./NotesAndFilesTab.vue?vue&type=script&lang=js&"
export * from "./NotesAndFilesTab.vue?vue&type=script&lang=js&"
import style0 from "./NotesAndFilesTab.vue?vue&type=style&index=0&id=be7b9d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7b9d16",
  null
  
)

export default component.exports